<div class="quotation-map-container">
  <div class="table-container">
    <table class="quotation-table" aria-hidden="true">
      <thead>
        <tr>
          <th class="code mat-mdc-header-cell">Código</th>
          <th class="product mat-mdc-header-cell">Produto</th>
          <th class="quantity mat-mdc-header-cell">Qtd</th>
          <th class="unit mat-mdc-header-cell">UM</th>
          <th class="history mat-mdc-header-cell"></th>
          @for (col of supplierColumns; track col; let i = $index) {
            <th
              class="supplier-header supplier-column mat-mdc-header-cell"
              [class.supplier-column-alt]="i % 2 === 0">
              <div class="supplier-info flex-col items-center justify-center">
                <div class="skeleton skeleton-supplier-name"></div>
                <div class="skeleton skeleton-supplier-email"></div>
                <div class="skeleton skeleton-supplier-chip"></div>
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        <tr class="validity-row mat-mdc-row">
          <td class="code mat-mdc-cell"></td>
          <td class="product mat-mdc-cell"></td>
          <td class="quantity mat-mdc-cell"></td>
          <td class="unit mat-mdc-cell"></td>
          <td class="history mat-mdc-cell"></td>
          @for (col of supplierColumns; track col; let i = $index) {
            <td
              class="supplier-cell supplier-column mat-mdc-cell"
              [class.supplier-column-alt]="i % 2 === 0">
              <div class="skeleton skeleton-validity-value"></div>
            </td>
          }
        </tr>
        @for (row of productRows; track row) {
          <tr class="product-row mat-mdc-row">
            <td class="code mat-mdc-cell">
              <div class="skeleton skeleton-code-text"></div>
            </td>
            <td class="product mat-mdc-cell">
              <div class="product-cell-content flex-col gap-4">
                <div class="skeleton skeleton-product-name"></div>
                <div class="skeleton skeleton-product-desc"></div>
                <div class="flex-row gap-8">
                  <div class="skeleton skeleton-product-chip"></div>
                </div>
              </div>
            </td>
            <td class="quantity mat-mdc-cell">
              <div class="skeleton skeleton-qty-text"></div>
            </td>
            <td class="unit mat-mdc-cell">
              <div class="skeleton skeleton-unit-text"></div>
            </td>
            <td class="history mat-mdc-cell">
              <div class="skeleton skeleton-history-icon"></div>
            </td>
            @for (col of supplierColumns; track col; let i = $index) {
              <td
                class="supplier-cell supplier-column mat-mdc-cell"
                [class.supplier-column-alt]="i % 2 === 0">
                <div class="supplier-quote-content">
                  <div class="price-row">
                    <div class="selected-price-container">
                      <div class="skeleton skeleton-checkbox"></div>
                      <div class="skeleton skeleton-price-text"></div>
                    </div>
                    <div class="negotiated-price-container">
                      <div class="skeleton skeleton-checkbox"></div>
                      <div class="skeleton skeleton-negotiated-field"></div>
                    </div>
                  </div>
                  <div class="skeleton skeleton-product-total"></div>
                </div>
              </td>
            }
          </tr>
        }
        <tr class="footer-row mat-mdc-row">
          <td class="code mat-mdc-cell"></td>
          <td class="product mat-mdc-cell">
            <div class="footer-label-content flex-row items-center gap-8">
              <span>Observações</span>
            </div>
          </td>
          <td class="quantity mat-mdc-cell"></td>
          <td class="unit mat-mdc-cell"></td>
          <td class="history mat-mdc-cell"></td>
          @for (col of supplierColumns; track col; let i = $index) {
            <td
              class="supplier-cell supplier-column mat-mdc-cell"
              [class.supplier-column-alt]="i % 2 === 0">
              <div class="footer-cell-content">
                <div class="skeleton skeleton-icon-circle"></div>
              </div>
            </td>
          }
        </tr>
        <tr class="footer-row mat-mdc-row">
          <td class="code mat-mdc-cell"></td>
          <td class="product mat-mdc-cell">
            <div class="footer-label-content flex-row items-center gap-8">
              <span>Formas de pagamento</span>
            </div>
          </td>
          <td class="quantity mat-mdc-cell"></td>
          <td class="unit mat-mdc-cell"></td>
          <td class="history mat-mdc-cell"></td>
          @for (col of supplierColumns; track col; let i = $index) {
            <td
              class="supplier-cell supplier-column mat-mdc-cell"
              [class.supplier-column-alt]="i % 2 === 0">
              <div class="footer-cell-content">
                <div class="skeleton skeleton-text-medium"></div>
              </div>
            </td>
          }
        </tr>
        <tr class="footer-row mat-mdc-row">
          <td class="code mat-mdc-cell"></td>
          <td class="product mat-mdc-cell">
            <div class="footer-label-content flex-row items-center gap-8">
              <span>Prazo do pagamento</span>
            </div>
          </td>
          <td class="quantity mat-mdc-cell"></td>
          <td class="unit mat-mdc-cell"></td>
          <td class="history mat-mdc-cell"></td>
          @for (col of supplierColumns; track col; let i = $index) {
            <td
              class="supplier-cell supplier-column mat-mdc-cell"
              [class.supplier-column-alt]="i % 2 === 0">
              <div class="footer-cell-content">
                <div class="skeleton skeleton-text-short"></div>
              </div>
            </td>
          }
        </tr>
        <tr class="footer-row mat-mdc-row">
          <td class="code mat-mdc-cell"></td>
          <td class="product mat-mdc-cell">
            <div class="footer-label-content flex-row items-center gap-8">
              <span>FRETE</span>
              <mat-icon class="freight-icon">info</mat-icon>
            </div>
          </td>
          <td class="quantity mat-mdc-cell"></td>
          <td class="unit mat-mdc-cell"></td>
          <td class="history mat-mdc-cell"></td>
          @for (col of supplierColumns; track col; let i = $index) {
            <td
              class="supplier-cell supplier-column mat-mdc-cell"
              [class.supplier-column-alt]="i % 2 === 0">
              <div class="footer-cell-content">
                <div class="skeleton skeleton-text-short"></div>
              </div>
            </td>
          }
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-row footer-row mat-mdc-footer-row">
          <td class="code mat-mdc-footer-cell"></td>
          <td class="product mat-mdc-footer-cell">
            <div class="footer-label-content flex-row items-center gap-8">
              <span>TOTAL DA NEGOCIAÇÃO</span>
            </div>
          </td>
          <td class="quantity mat-mdc-footer-cell"></td>
          <td class="unit mat-mdc-footer-cell"></td>
          <td class="history mat-mdc-footer-cell"></td>
          @for (col of supplierColumns; track col; let i = $index) {
            <td
              class="supplier-cell supplier-column mat-mdc-footer-cell"
              [class.supplier-column-alt]="i % 2 === 0">
              <div class="footer-cell-content">
                <div class="skeleton skeleton-total-value"></div>
              </div>
            </td>
          }
        </tr>
      </tfoot>
    </table>
  </div>
  <div class="add-supplier-panel">
    <button
      matButton="text"
      type="button"
      class="add-supplier-button"
      disabled>
      <mat-icon aria-hidden="true">add</mat-icon>
      Adicionar Fornecedor
    </button>
  </div>
</div>
